import { CheckCircleOutlined } from '@ant-design/icons';
import { Certificate } from '@revenuemarket/bank';
import { Flex } from '@revenuemarket/cds';
import { colorTokens, colors } from '@revenuemarket/design';
import { Convert } from '@revenuemarket/react';
import { InfoCircleIcon, ExclamationCircleIcon } from '@revenuemarket/ui';
import { countDaysBetween } from '@revenuemarket/utils/days';
import { Tag, Typography } from 'antd';
import dayjs from 'dayjs';

const CERTIFICATE_MAP = {
  NORMAL: {
    text: '정상',
  },
  EXPIRED: {
    text: '만료',
  },
  STALE: {
    text: '사용불가',
  },
  EXPIRE_SOON: {
    text: '만료예정',
  },
};

interface CertificateInfoProps {
  certificate: Certificate;
}

const CertificateInfo: React.FC<CertificateInfoProps> = ({ certificate }) => {
  const certificateExpired = certificate.status === 'EXPIRED';
  const certificateAbnormal = certificate.status === 'STALE' || certificate.status === 'EXPIRED';

  return (
    <Flex gap={12} align="center">
      <Convert
        value={certificate}
        expression={(certificate) => (
          <Tag
            icon={<CheckCircleOutlined />}
            color={certificate.status === 'NORMAL' ? 'success' : 'error'}
          >
            {CERTIFICATE_MAP[certificate.status].text}
          </Tag>
        )}
      />
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Typography.Title
            level={5}
            style={{
              fontWeight: 400,
              margin: 0,
            }}
          >
            {certificate.certificateOwner}
          </Typography.Title>
          <div style={{ display: 'flex', gap: 24 }}>
            {(certificate.certificateAuthority || certificate.certificateType) && (
              <Typography.Text
                style={{ color: colorTokens.textDescription }}
              >{`${certificate.certificateAuthority} · ${certificate.certificateType}`}</Typography.Text>
            )}
            <div style={{ display: 'flex', gap: 4 }}>
              <Typography style={{ color: colorTokens.textDescription }}>만료일</Typography>
              <Typography
                style={{ color: certificateExpired ? colors.red1000 : colorTokens.textDescription }}
              >
                {certificate.certificateExpireDate}
              </Typography>
            </div>
          </div>
          {certificate.status === 'EXPIRE_SOON' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <InfoCircleIcon width={13} height={13} fill={colors.indigo1000} />
              <Typography.Text style={{ color: colors.indigo1000 }}>
                공동인증서가 {countDaysBetween(dayjs(certificate.certificateExpireDate), dayjs())}일
                후에 만료됩니다. 인증서 갱신 후 다시 등록해주세요.
              </Typography.Text>
            </div>
          )}
          {certificateAbnormal && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <ExclamationCircleIcon width={13} height={13} fill={colors.red1000} />
              <Typography.Text style={{ color: colors.red1000 }}>
                공동인증서가 사용 불가능한 상태입니다. 삭제 후 다시 등록해주세요.
              </Typography.Text>
            </div>
          )}
        </div>
      </div>
    </Flex>
  );
};

export default CertificateInfo;
